import type { FC } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { AutoplayStartButton } from '@pp/core/src/components/game/autoplayV2/buttons/startButton/AutoplayStartButton';

import { Bets } from '../../../../config/bets';
import { useValidBetInputValue } from '../../../gameGrid/hooks/useValidBetInputValue';

export interface AutoplayStartButtonConnectedProps {
  betId: Bets;
  count: number;
  handleClick: () => void;
}

export const CrashAutoplayStartButtonConnected: FC<AutoplayStartButtonConnectedProps> = ({
  betId,
  count,
  handleClick,
}) => {
  const { betInputAmount } = useValidBetInputValue(betId);

  return (
    <AutoplayStartButton
      count={count}
      totalBet={<CurrencyConnected value={betInputAmount * count} />}
      onClick={handleClick}
      disabled={betInputAmount <= 0}
    />
  );
};
